import React from 'react';
import LeftArrow from '../assets/images/LeftArrow.svg';

export default () => {
  return <img src={LeftArrow} alt="" />;
};
